module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: ใบซ่อมใหม่ (ลูกค้านำเข้าศูนย์)","page.description":"เปิดงานซ่อมสำหรับ Drone ที่ลูกค้านำเข้าศูนย์","service_create.confirm.title":"ยืนยันการเปิดงานซ่อม","service_create.confirm.message":"คุณต้องการยืนยันการเปิดงานซ่อมตามนี้ ?","service_create.success":"เปิดงานซ่อมเรียบร้อยด้วย เลขอ้างอิง {service}","service_create.submit.label":"เปิดงานซ่อม"}}')
  delete Component.options._Ctor
}
